<template>
  <div class="create_wrapper fadeIn">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("addNew") }}</h4>
      </div>
      <!-- <UplodeMultiple></UplodeMultiple> -->
      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <div class="row justify-content-between product">
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isArabic"
                  v-model.trim="data.title_ar"
                />
                <label for="name_input" class="form-label">
                  المسمى الوظيفي (عربي)</label
                >
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isEnglish"
                  v-model.trim="data.title_en"
                />
                <label for="name_input" class="form-label"
                  >المسمى الوظيفي (إنجليزي)</label
                >
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isArabic"
                  v-model.trim="data.location_ar"
                />
                <label for="name_input" class="form-label"
                  >العنوان (عربي)</label
                >
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isEnglish"
                  v-model.trim="data.location_en"
                />
                <label for="name_input" class="form-label"
                  >العنوان (إنجليزي)</label
                >
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper">
                <!-- <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isArabic"
                  v-model.trim="data.experience_position_ar"
                /> -->
                <label for="name_input" class="form-label">
                  المؤهل الجامعي(عربي)</label
                >
                <multiselect
                  v-model="data.experience_position_ar"
                  :options="experiencePositionsAr"
                  label="name"
                  track-by="id"
                  placeholder=""
                  :searchable="false"
                  :allow-empty="false"
                  :show-labels="false"
                >
                  <template slot="option" slot-scope="props">
                    <span class="option__title">
                      {{ props.option.name }}
                    </span>
                  </template>
                </multiselect>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper">
                <!-- <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isEnglish"
                  v-model.trim="data.experience_position_en"
                /> -->
                <label for="name_input" class="form-label">
                  المؤهل الجامعي (إنجليزي)</label
                >
                <multiselect
                  v-model="data.experience_position_en"
                  :options="experiencePositionsEn"
                  label="name"
                  track-by="id"
                  placeholder=""
                  :searchable="false"
                  :allow-empty="false"
                  :show-labels="false"
                >
                  <template slot="option" slot-scope="props">
                    <span class="option__title">
                      {{ props.option.name }}
                    </span>
                  </template>
                </multiselect>
              </div>
            </div>

            <div class="col-lg-6 py-0">
              <div class="input_wrapper">
                <label for="textarea_1" class="form-label">
                  نبذة مختصرة عن الوظيفة (عربي)</label
                >
                <base-input
                  col="12"
                  type="ckeditor"
                  :required="true"
                  v-model="data.description_ar"
                />
                <!-- <vue-editor v-model="data.description_ar"></vue-editor> -->
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper">
                <label for="textarea_1" class="form-label">
                  نبذة مختصرة عن الوظيفة (إنجليزي)</label
                >
                <base-input
                  col="12"
                  type="ckeditor"
                  :required="true"
                  v-model="data.description_en"
                />

                <!-- <vue-editor v-model="data.description_en"></vue-editor> -->
              </div>
            </div>
            <div class="col-lg-6 me-auto py-0">
              <div class="input_wrapper">
                <label class="form-label">قسم / تخصص الوظيفة</label>
                <multiselect
                  v-model="data.category_id"
                  :options="categories"
                  label="title"
                  track-by="id"
                  placeholder=""
                  :searchable="false"
                  :allow-empty="false"
                  :show-labels="false"
                >
                  <template slot="option" slot-scope="props">
                    <span class="option__title">
                      {{ props.option.title }}
                    </span>
                  </template>
                </multiselect>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model="data.experience_years"
                />
                <label for="name_input" class="form-label"> سنوات الخبرة</label>
              </div>
            </div>
            <div class="col-lg-12">
              <h5 class="mb-5">المسؤليات</h5>
              <div
                class="row"
                v-for="(item, index) in data.responsibilities"
                :key="index"
              >
                <div class="row justify-content-between flex-warp py-3 col-10">
                  <div class="col-lg-6 py-0">
                    <div class="input_wrapper top_label">
                      <label for="textarea_1" class="form-label">
                        المحتوي (عربي)</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        @input="helper_checkIfInputIsEmpty"
                        v-model="item.description_ar"
                      />
                      <!-- <vue-editor v-model="content.description_ar"></vue-editor> -->
                    </div>
                  </div>
                  <div class="col-lg-6 py-0">
                    <div class="input_wrapper top_label">
                      <label for="textarea_1" class="form-label">
                        المحتوي (إنجليزي)</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        @input="helper_checkIfInputIsEmpty"
                        v-model="item.description_en"
                      />
                      <!-- <vue-editor v-model="content.description_en"></vue-editor> -->
                    </div>
                  </div>
                </div>
                <!-- Actions -->
                <div class="col-1 py-0" v-if="data.responsibilities.length > 0">
                  <span class="append" @click="appendResponsibilities()">
                    <i class="fas fa-plus-circle"></i>
                  </span>
                </div>
                <div
                  class="col-1 py-0"
                  v-show="data.responsibilities.length > 1"
                >
                  <span class="append" @click="deleteResponsibilities(index)">
                    <i class="fas fa-minus-circle"></i>
                  </span>
                </div>
              </div>
            </div>
            <hr />
            <div class="col-lg-12">
              <h5 class="mb-5">المتطالبات</h5>
              <div
                class="row"
                v-for="(item, index) in data.requirements"
                :key="index"
              >
                <div class="row justify-content-between flex-warp py-3 col-10">
                  <div class="col-lg-6 py-0">
                    <div class="input_wrapper top_label">
                      <label for="textarea_1" class="form-label">
                        المحتوي (عربي)</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        @input="helper_checkIfInputIsEmpty"
                        v-model="item.description_ar"
                      />
                      <!-- <vue-editor v-model="content.description_ar"></vue-editor> -->
                    </div>
                  </div>
                  <div class="col-lg-6 py-0">
                    <div class="input_wrapper top_label">
                      <label for="textarea_1" class="form-label">
                        المحتوي (إنجليزي)</label
                      >
                      <!-- <base-input
                                          type="text"
                                          :required="true"
                                          v-model="item.description_en"
                                        /> -->
                      <input
                        type="text"
                        class="form-control"
                        @input="helper_checkIfInputIsEmpty"
                        v-model="item.description_en"
                      />
                      <!-- <vue-editor v-model="content.description_en"></vue-editor> -->
                    </div>
                  </div>
                </div>
                <div class="col-1 py-0" v-if="data.requirements.length > 0">
                  <span class="append" @click="appendRequirements()">
                    <i class="fas fa-plus-circle"></i>
                  </span>
                </div>
                <div class="col-1 py-0" v-show="data.requirements.length > 1">
                  <span class="append" @click="deleteRequirements(index)">
                    <i class="fas fa-minus-circle"></i>
                  </span>
                </div>
              </div>
              <!-- Actions -->
            </div>
            <!-- start Add to website or No  -->
            <div class="py-0 row justify-content-center has_project py-3">
              <div class="col-12">
                <div
                  class="top_label row justify-content-start align-items-center"
                >
                  <div class="">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      name="category"
                      id="project"
                      value="true"
                      v-model="data.is_active"
                    />
                    <label for="project"> نشر في الموقع </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- End Add to website or No  -->
            <div class="buttons_wrapper">
              <button class="base-btn">
                {{ $t("forms.submit") }}
                <span class="btn_loader" v-if="btnIsLoading"></span>
              </button>
            </div>
          </div>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",

  data() {
    return {
      // Vue tags
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.careers.title"),
          disabled: false,
          href: "/careers",
        },
        {
          text: this.$t("breadcrumb.careers.add"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,
      categories: [],
      experiencePositionsEn: [
        {
          id: 1,
          name: "Student",
        },
        {
          id: 2,
          name: "Bachelor's degree",
        },
        {
          id: 3,
          name: "Master's degree",
        },
        {
          id: 4,
          name: "Others",
        },
      ],
      experiencePositionsAr: [
        {
          id: 1,
          name: "طالب",
        },
        {
          id: 2,
          name: "درجة البكالوريوس",
        },
        {
          id: 3,
          name: "درجة الماجستير",
        },
        {
          id: 4,
          name: "أخري",
        },
      ],
      // ========== create_data
      data: {
        title_ar: null,
        title_en: null,
        location_ar: null,
        location_en: null,
        experience_position_ar: null,
        experience_position_en: null,
        description_ar: null,
        description_en: null,
        is_active: null,
        icon: null,
        experience_years: null,
        category_id: null,
        responsibilities: [
          {
            description_ar: null,
            description_en: null,
          },
        ],
        requirements: [
          {
            description_ar: null,
            description_en: null,
          },
        ],
      },
    };
  },

  computed: {},

  methods: {
    appendRequirements() {
      this.data.requirements.push({
        description_ar: null,
        description_en: null,
      });
    },
    deleteRequirements(index) {
      this.data.requirements.splice(index, 1);
    },
    appendResponsibilities() {
      this.data.responsibilities.push({
        description_ar: null,
        description_en: null,
      });
    },
    deleteResponsibilities(index) {
      this.data.responsibilities.splice(index, 1);
    },

    // Validate Data
    validateCreateForm() {
      // let validate=false
      this.btnIsLoading = true;
      if (!this.data.title_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  اسم الوظيفة  مطلوب (عربي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.title_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  اسم الوظيفة  مطلوب (أنجليزي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.location_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  عنوان الوظيفة  مطلوب (عربي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.location_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  عنوان الوظيفة  مطلوب (أنجليزي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.experience_position_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  مسمي الخبرة مطلوبة (عربي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.experience_position_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  مسمي الخبرة  مطلوبة (أنجليزي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.description_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  الوصف  مطلوبة (عربي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.description_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: "   الوصف  مطلوبة (أنجليزي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
        // }  else if (!this.data.icon) {
        //     this.$iziToast.error({
        //       timeout: 2000,
        //       message: '  الايكون  مطلوبة ',
        //       position: 'bottomRight',
        //     })
        //     this.btnIsLoading = false
        //     return
      } else if (!this.data.category_id) {
        this.$iziToast.error({
          timeout: 2000,
          message: "   قسم / تخصص الوظيفة  مطلوبة  ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        this.submitData();
        return;
      } else {
        this.btnIsLoading = false;
        this.submitData();
        return;
      }
      //  else{
      //   if (validate) return;
      //   this.data.requirements.map((section,index)=>{
      //       if (validate) return;
      //       if( !section.description_ar){
      //         this.$iziToast.error({
      //             timeout: 2000,
      //             message: ` المحتوي في المحور رقم ${index + 1}  مطلوب (عربي)`,
      //             position: "bottomRight",
      //           });
      //           validate = true;
      //           this.btnIsLoading = false;
      //           return;
      //       } else if( !section.description_en){
      //         this.$iziToast.error({
      //             timeout: 2000,
      //             message: ` المحتوي في المحور رقم ${index + 1}  مطلوب (أنجليزي)`,
      //             position: "bottomRight",
      //           });
      //           validate = true;
      //           this.btnIsLoading = false;
      //           return;}
      //     });
      // }
      //   return
      // }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();

      submit_data.append("ar[title]", this.data.title_ar);
      submit_data.append("en[title]", this.data.title_en);
      submit_data.append("ar[location]", this.data.location_ar);
      submit_data.append("en[location]", this.data.location_en);
      submit_data.append(
        `ar[experience_position]`,
        this.data.experience_position_ar.name
      );
      submit_data.append(
        `en[experience_position]`,
        this.data.experience_position_en.name
      );
      submit_data.append(`ar[description]`, this.data.description_ar);
      submit_data.append(`en[description]`, this.data.description_en);
      // submit_data.append(`icon`,  this.data.icon)
      submit_data.append(`is_active`, +this.data.is_active);
      submit_data.append(`experience_years`, this.data.experience_years);
      submit_data.append(`category_id`, this.data.category_id.id);
      this.data.responsibilities.map((item, index) => {
        submit_data.append(
          `responsibilities[${index}][ar][description]`,
          item.description_ar
        );
        submit_data.append(
          `responsibilities[${index}][en][description]`,
          item.description_en
        );
      });
      this.data.requirements.map((item, index) => {
        submit_data.append(
          `requirements[${index}][ar][description]`,
          item.description_ar
        );
        submit_data.append(
          `requirements[${index}][en][description]`,
          item.description_en
        );
      });

      this.axios({
        method: "POST",
        url: "career",
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("addSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/careers" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
    getCategories() {
      this.loading = true;
      this.axios({
        method: "GET",
        url: "career_category_without_pagination",
        params: { internal: 1 },
      })
        .then((res) => {
          this.categories = res.data.data;

          // this.loading = false
        })
        .catch(() => {
          // this.loading = false
        });
    },
  },

  mounted() {
    this.getCategories();
  },
};
</script>

<style lang="scss" scoped>
.product {
  .chooseImage {
    width: auto !important;
  }
}

.productDetails {
  border: 1px solid #339989;
  border-radius: 15px;
  padding-block: 20px;

  &.disabled {
    cursor: not-allowed;

    h3 {
      color: gray;
      font-size: 25px;
    }

    h4 {
      font-size: 21px;
      color: gray;
    }

    & > * {
      pointer-events: none;
    }
  }
}
</style>
<style lang="scss">
.ti-input {
  border: 0px !important;
}
.vue-tags-input {
  max-width: unset !important;
  width: 100% !important;
}
</style>
